import messages from "@smartmixin/i18n/dist/translations/pl.json";

export default messages;
